(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2758],{

/***/ 42758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero073": function() { return /* binding */ Hero073; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Hero073_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54104);
/* harmony import */ var _Hero073_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Hero073_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Hero073 = function(param) {
    var payload = param.payload;
    var ref;
    var headline = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero073_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero073_module_scss__WEBPACK_IMPORTED_MODULE_3___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                        className: (_Hero073_module_scss__WEBPACK_IMPORTED_MODULE_3___default().headline),
                        color: "dark",
                        children: headline
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                        value: description,
                        color: "dark",
                        className: (_Hero073_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description)
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero073);


/***/ }),

/***/ 54104:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero073_wrapper__ktMrT","block":"Hero073_block__vrHch","headline":"Hero073_headline__mbzNq","description":"Hero073_description__wx06r"};

/***/ })

}]);